import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import BillingIcon from '@mui/icons-material/Payment'
import SettingsIcon from '@mui/icons-material/Settings'

import SubMenu, { MenuItem, SubMenuWithResourcesProps } from 'dash/layout/menu/sub_menu'

type AccountMenuProps = SubMenuWithResourcesProps

export const AccountMenu: FC<AccountMenuProps> = ({ dense, onMenuClick, resources, sidebarIsOpen }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [menuItems, setMenuItems] = useState<MenuItem[]>([])

  const compareFunction = (a: { name: string }, b: { name: string }): number => {
    if (a.name == 'User') return -1
    if (b.name == 'User') return 1
    return 0
  }

  useEffect(() => {
    if (resources && resources.length > 0) {
      const menuItems: MenuItem[] = [...resources]

      menuItems.splice(2, 0, {
        name: 'Billing',
        route: `/account/:account_id/billing`,
        icon: BillingIcon,
      })

      const settingsMenuItem = menuItems.find((mi) => mi.name == 'account')
      if (settingsMenuItem) {
        settingsMenuItem.name += '/:account_id'
        settingsMenuItem.icon = SettingsIcon
      }

      setMenuItems(menuItems)
    }
  }, [resources])

  return (
    <SubMenu
      compareFunction={compareFunction}
      dense={dense}
      flatten
      handleToggle={() => setIsOpen(!isOpen)}
      // icon={<AccountCircleIcon />}
      // isOpen={isOpen}
      isOpen
      menuItems={menuItems}
      name="My Account"
      onMenuClick={onMenuClick}
      sidebarIsOpen={sidebarIsOpen}
      subMenuKey="account"
    />
  )
}
